import { useSelector } from "react-redux";
import type { RootState } from "StoreTypes";

// Hook version - must be called at top level of component
export const useModalOpen = (modalName: string): boolean =>
  useSelector(
    (state: RootState) =>
      state.modals?.modalSettings[modalName]?.isOpen || false,
  );

// Selector function - for use with useSelector directly
export const selectModalOpen = (modalName: string) => (state: RootState) =>
  state.modals?.modalSettings[modalName]?.isOpen || false;

export enum ModalType {
  MoveRoundModal = "moveRoundModal",
  MultiSimControlModal = "multiSimControlModal",
  SimControlModal = "simControlModal",
  RoundControlModal = "roundControlModal",
  ScorecardModal = "scorecardModal",
  RoundConfigurationDeleteConfirm = "roundConfigurationDeleteConfirm",
  SendSimulatorMessage = "sendSimulatorMessageModal",
  League = "leagueDeleteModal",
  ConfirmDeleteAlert = "confirmDelete",
  LeagueRoundGroups = "leagueRoundGroupsModal",
  RoundPresets = "roundPresetsModal",
  QueueModal = "queueModal",
  MarketingModal = "marketingModal",
  HandicapModal = "handicapModal",
  ScorecardSearch = "scorecardSearchModal",
  LeagueLeaderboard = "leagueLeaderboardModal",
  LeagueRoundLeaderboard = "leagueRoundLeaderboardModal",
  LeaugeCreateEdit = "leagueCreateEditModal",
  LeagueRoster = "leagueRosterModal",
  LeagueRoundsModal = "leagueRoundsModal",
  RexReservationModal = "rexReservationModal",
  SimManagementModal = "simManagementModal",
  LatestScreenshotModal = "latestScreenshotModal",
  FacilityManagementModal = "facilityManagementModal",
  SimulatorAlertsModal = "simulatorAlertsModal",
  FacilityAdminModal = "facilityAdminModal",
  CompetitionLeaderboard = "competitionLeaderboardModal",
  CompetitionDetails = "competitionDetailsModal",
  EventImageManager = "eventImageManagerModal",
}

export const modalName = (prefix: string, key?: string | null): string => {
  return key ? `${prefix}-${key}` : prefix;
};
